import { render, staticRenderFns } from "./TaskClosureProfileEdit.vue?vue&type=template&id=fcae5382&scoped=true"
import script from "./TaskClosureProfileEdit.vue?vue&type=script&lang=js"
export * from "./TaskClosureProfileEdit.vue?vue&type=script&lang=js"
import style0 from "./TaskClosureProfileEdit.vue?vue&type=style&index=0&id=fcae5382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcae5382",
  null
  
)

export default component.exports